'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var filter = require('it-filter');

var take = require('it-take');

var merge = require('it-merge');

var base = require('./base.js');

var keytransform = require('./keytransform.js');

var errors = require('./errors.js');

var utils = require('./utils.js');

var key = require('interface-datastore/key');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var filter__default = /*#__PURE__*/_interopDefaultLegacy(filter);

var take__default = /*#__PURE__*/_interopDefaultLegacy(take);

var merge__default = /*#__PURE__*/_interopDefaultLegacy(merge);

var MountDatastore = /*#__PURE__*/function (_base$BaseDatastore) {
  _inherits(MountDatastore, _base$BaseDatastore);

  var _super = _createSuper(MountDatastore);

  function MountDatastore(mounts) {
    var _this;

    _classCallCheck(this, MountDatastore);

    _this = _super.call(this);
    _this.mounts = mounts.slice();
    return _this;
  }

  _createClass(MountDatastore, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all(this.mounts.map(function (m) {
                  return m.datastore.open();
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "_lookup",
    value: function _lookup(key$1) {
      var _iterator = _createForOfIteratorHelper(this.mounts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mount = _step.value;

          if (mount.prefix.toString() === key$1.toString() || mount.prefix.isAncestorOf(key$1)) {
            var s = utils.replaceStartWith(key$1.toString(), mount.prefix.toString());
            return {
              datastore: mount.datastore,
              mountpoint: mount.prefix,
              rest: new key.Key(s)
            };
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "put",
    value: function put(key, value, options) {
      var match = this._lookup(key);

      if (match == null) {
        throw errors.dbWriteFailedError(new Error('No datastore mounted for this key'));
      }

      return match.datastore.put(match.rest, value, options);
    }
  }, {
    key: "get",
    value: function get(key, options) {
      var match = this._lookup(key);

      if (match == null) {
        throw errors.notFoundError(new Error('No datastore mounted for this key'));
      }

      return match.datastore.get(match.rest, options);
    }
  }, {
    key: "has",
    value: function has(key, options) {
      var match = this._lookup(key);

      if (match == null) {
        return Promise.resolve(false);
      }

      return match.datastore.has(match.rest, options);
    }
  }, {
    key: "delete",
    value: function _delete(key, options) {
      var match = this._lookup(key);

      if (match == null) {
        throw errors.dbDeleteFailedError(new Error('No datastore mounted for this key'));
      }

      return match.datastore.delete(match.rest, options);
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all(this.mounts.map(function (m) {
                  return m.datastore.close();
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "batch",
    value: function batch() {
      var _this2 = this;

      var batchMounts = {};

      var lookup = function lookup(key) {
        var match = _this2._lookup(key);

        if (match == null) {
          throw new Error('No datastore mounted for this key');
        }

        var m = match.mountpoint.toString();

        if (batchMounts[m] == null) {
          batchMounts[m] = match.datastore.batch();
        }

        return {
          batch: batchMounts[m],
          rest: match.rest
        };
      };

      return {
        put: function put(key, value) {
          var match = lookup(key);
          match.batch.put(match.rest, value);
        },
        delete: function _delete(key) {
          var match = lookup(key);
          match.batch.delete(match.rest);
        },
        commit: function () {
          var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return Promise.all(Object.keys(batchMounts).map(function (p) {
                      return batchMounts[p].commit(options);
                    }));

                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function commit(_x) {
            return _commit.apply(this, arguments);
          }

          return commit;
        }()
      };
    }
  }, {
    key: "query",
    value: function query(q, options) {
      var qs = this.mounts.map(function (m) {
        var ks = new keytransform.KeyTransformDatastore(m.datastore, {
          convert: function convert(key) {
            throw new Error('should never be called');
          },
          invert: function invert(key) {
            return m.prefix.child(key);
          }
        });
        var prefix;

        if (q.prefix != null) {
          prefix = utils.replaceStartWith(q.prefix, m.prefix.toString());
        }

        return ks.query({
          prefix: prefix,
          filters: q.filters
        }, options);
      });
      var it = merge__default['default'].apply(merge__default, _toConsumableArray(qs));
      if (q.filters) q.filters.forEach(function (f) {
        it = filter__default['default'](it, f);
      });
      if (q.orders) q.orders.forEach(function (o) {
        it = utils.sortAll(it, o);
      });

      if (q.offset != null) {
        var i = 0;
        it = filter__default['default'](it, function () {
          return i++ >= q.offset;
        });
      }

      if (q.limit != null) it = take__default['default'](it, q.limit);
      return it;
    }
  }, {
    key: "queryKeys",
    value: function queryKeys(q, options) {
      var qs = this.mounts.map(function (m) {
        var ks = new keytransform.KeyTransformDatastore(m.datastore, {
          convert: function convert(key) {
            throw new Error('should never be called');
          },
          invert: function invert(key) {
            return m.prefix.child(key);
          }
        });
        var prefix;

        if (q.prefix != null) {
          prefix = utils.replaceStartWith(q.prefix, m.prefix.toString());
        }

        return ks.queryKeys({
          prefix: prefix,
          filters: q.filters
        }, options);
      });
      var it = merge__default['default'].apply(merge__default, _toConsumableArray(qs));
      if (q.filters) q.filters.forEach(function (f) {
        it = filter__default['default'](it, f);
      });
      if (q.orders) q.orders.forEach(function (o) {
        it = utils.sortAll(it, o);
      });

      if (q.offset != null) {
        var i = 0;
        it = filter__default['default'](it, function () {
          return i++ >= q.offset;
        });
      }

      if (q.limit != null) it = take__default['default'](it, q.limit);
      return it;
    }
  }]);

  return MountDatastore;
}(base.BaseDatastore);

exports.MountDatastore = MountDatastore;